import React from "react";

const sofiya_rukadikar = () => {
  return (
    <div>
      <h1>Sofiya Rukadikar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The initial criteria for shortlisting was CGPA-based, i.e
        <br />
        Eligible Branches: CS/E\&amp;TC/ELECTRICAL/INSTRU
        <br />
        Eligible Criteria:{" "}
      </p>

      <ol>
        <li>Computer — 7 CGPA &amp; Above with no backlog </li>
        <li>E\&amp;TC/Elect/Instru — 8 CGPA &amp; Above with no backlog</li>
      </ol>

      <p>
        A list of all eligible students was shared before the aptitude test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The entire process was divided into 4 rounds
      </p>

      <ol>
        <li>Aptitude -day 1 </li>
        <li>Tech 1-day 1 </li>
        <li>Tech 2 -day 2 </li>
        <li>HR -day 2</li>
      </ol>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round consisted of 3 sections,{" "}
      </p>

      <ol>
        <li>
          coding question - it was a DP question (and mostly they ask DP and
          graph questions for this part, as far as what I've read){" "}
        </li>
        <li>
          technical section - this included oops, networking, DBMS, basically cs
          fundamental questions (these were comparatively easy, you just needed
          clear fundamentals){" "}
        </li>
        <li>
          Quant question - they asked quantitative aptitude questions, mainly
          focused on topics like probability, mathematical reasoning, patterns,
          and related concepts. You can refer to various platforms such as
          IndiaBix, InterviewBit, or GeeksforGeeks for practicing similar types
          of questions.
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        12 students were shortlisted after the Aptitude round
        <br />
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
      </p>

      <p>
        The shortlist after the aptitude test was released on the same day, and
        the Tech 1 interviews also began that day. Due to time constraints, some
        interviews had to be continued the next day. Initially, I was told that
        my interview would be scheduled for the following day, but because of
        time shifts, it was conducted on the same day as the aptitude test that
        said, I didn’t get much time to prepare for Tech 1 after the aptitude
        test.
      </p>

      <p>
        For Tech 2, which was scheduled for the next day, I reviewed my resume
        at night and went over some core CS fundamentals that could be asked.
        Most of the questions revolved around my exposure to topics I had
        already studied or read, and the preparation I had done earlier.
      </p>

      <p>
        My suggestion:{" "}
        <em>
          don’t leave anything important to the last moment. Stay calm and
          confident, and own the experiences and skills you’ve listed on your
          resume.
        </em>
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <ol>
        <li>
          Aptitude - 153 students were shortlisted for this round
          <br />
          This round was an online assessment on hackerrank platform that
          <br />
          Included 3 sections coding, technical and quant{" "}
        </li>
        <li>
          Technical Round 1 -16 students were shortlisted for this round
          <br />
          This round was majorly focused on my projects that I put up on my
          resume (the flow ,approach ,tech stack used) . I explained the
          approach and was later counter questioned on it.
          <br />I was aksed dsa questions (tweaked lru cache and its time
          complexity ) many networking scenarios and dbms based question as well
          as technical scenario based questions were asked{" "}
        </li>
        <li>
          Technical Round 2 - 6 students were shortlisted for this round
          <br />
          This round majorly focused on my internships and projects. I was also
          asked high-level design of a system and the flow, and what changes I
          would make to tackle certain scenarios.Apart from project-related
          questions, there were also a few miscellaneous technical questions to
          test my problem-solving and conceptual understanding for instance, how
          I would implement the random() function without using any standard
          library, and several questions related to Computer Organization.{" "}
        </li>
        <li>
          HR -6 students were shortlisted for this round
          <br />
          This round was very short as compared to the other two, no technical
          questions were asked here; it was more like a small talk and getting
          to know what I felt about this job and the company. My suggestion
          would be attend the ppt so you get to speak about those points.{" "}
        </li>
        <li>Results were announced the same day -2 received the final offer</li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        It was focused on projects, DSA, networks, DBMS, and scenario-based
        questions
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ol>
        <li>Striver A-Z sheet </li>
        <li>Gfg Archives </li>
        <li>Gfg company-specific sheet </li>
        <li>Neetcode blind 75 </li>
        <li>Interviewbit's top Interview questions </li>
        <li>Cracking the Coding Interview book </li>
      </ol>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice and practice until all you can think about is only solving that
        one question, trust me, it becomes the highlight of your day when all
        your test cases pass (after hell loads of failure and thoughts of
        dropping out) and it's okay to study the same thing again and again
        until you get a hold of it!
        <br />
        Dont keep on searching forever ! pick up a good resource and stick to it
        end to end , whatever works out for you (I chose the Striver sheet)
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Most of the questions asked were project based, they are trying to
        understand your approach of building things and thought process behind
        building it, why you chose what you chose and what are the alternatives
        (essentially checking if I had researched and thought things through
        before implementation ) so make sure to know your projects inside out, i
        was also asked about my extracurricular and clubs that i had mentioned{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        There’s nothing overly specific you need to prepare for this company,
        you just need to be clear with your basics and answer confidently. Trust
        me when I say confidence is the key, communicate as much as you can, and
        be sure that what you wanted to explain was understood by them. Explain
        multiple approaches, take your time, but be clear with the question,
        don't divert from it
        <br />
        (You can use the provided pen and paper to explain your points even
        clearly )<br />
        Also, be mindful of what you mention during the interview, you may be
        asked follow-up questions on those topics as well. It's not what you
        study the night before, but what you have been studying till now.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Start your preparation early, but don’t let it overwhelm you. Treat it
        as part of the journey and try to enjoy the process... every step has a
        lot to teach you. Always keep your purpose in front of your eyes, and
        stay hopeful.
      </p>

      <p>Everything will work out!</p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong> <a href="mailto:rukadikarss24.comp@coeptech.ac.in">rukadikarss24.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>
        <a href="https://www.linkedin.com/in/sofiya-rukadikar">
          Sofiya Rukadikar
        </a>
      </p>
    </div>
  );
};

export default sofiya_rukadikar;
